import React from "react";
import {classNames} from "@utils/class-names";
import {ExerciseDetails} from "../../core/models/interfaces/exercise-details.interface";
import SelectedCheckmark from "./ui/selected-checkmark";
import YouTubeThumbnail from "@common/components/youtube-thumbnail";

interface ExerciseCardProps {
    exercise: ExerciseDetails;
    selected: boolean;
    onToggle: () => void;
}

const ExerciseCard: React.FC<ExerciseCardProps> = ({exercise, selected, onToggle}) => {
    const handleOpenLink = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        if (exercise.url) {
            window.open(exercise.url, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <div
            onClick={onToggle}
            className={classNames(
                "group rounded-2xl p-2 pl-3 cursor-pointer transition-all duration-200",
                "flex justify-between items-center gap-3",
                selected && "bg-success/10",
                !selected && "hover:bg-input-background/5"
            )}
        >
            <YouTubeThumbnail
                url={exercise.url}
                onOpen={handleOpenLink}
                className="w-20 h-[45px]"
            />
            <div className="flex flex-1 flex-col gap-1 min-w-0">
                <h3 className="font-semibold text-base leading-[20px] truncate">
                    {exercise.title}
                </h3>
                {exercise.description && (
                    <div className="text-sm text-on-surface/80 leading-[18px] line-clamp-1">
                        {exercise.description}
                    </div>
                )}
            </div>
            <div className="flex items-center gap-2 shrink-0">
                {selected && (
                    <div className="bg-success rounded-full">
                        <SelectedCheckmark/>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExerciseCard;
